module.exports = __webpack_public_path__ + "static/media/speechProduction6c7c0117.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/speechProduction.svg
// module id = 1343
// module chunks = 0